export default {
    athena: {
        que: "Consultas SQL directamente sobre archivos en S3, sin servidores ni cargar datos antes. Pagas por los datos que cada consulta lee.",
        patron: "lineal",
        nodos: [["Analista", "usuario"], ["Athena (SQL)", "lupa"], ["Catálogo (Glue)", "carpeta"], ["Datos en S3", "datos"]],
        pasos: ["El analista escribe una consulta SQL.", "Athena consulta el catálogo para saber qué tablas y archivos existen.", "Lee los archivos de S3 en paralelo y entrega el resultado (que también guarda en S3)."],
        objetos: {
            "Consultas": ["SQL ejecutado sobre tablas definidas en el catálogo, con su costo según los bytes leídos.", 1],
            "Workgroups": ["Separan equipos con límites de costo y ubicación de resultados.", 1],
            "Data Catalogs": ["Metadatos de tablas; por defecto el catálogo de Glue.", 2],
        },
    },
    glue: {
        que: "Preparación de datos (ETL) sin servidores: descubre la estructura de tus datos, los transforma con código y los deja listos para analizar.",
        patron: "lineal",
        nodos: [["Datos de origen", "datos"], ["Crawler", "lupa"], ["Catálogo de datos", "carpeta"], ["Job ETL", "engranaje"]],
        pasos: ["Un crawler recorre los datos y detecta columnas y tipos.", "Crea o actualiza las tablas en el catálogo de datos.", "Un job ETL (Spark/Python) las lee, transforma y escribe el resultado en el destino."],
        objetos: {
            "Bases de datos": ["Agrupaciones lógicas de tablas del catálogo.", 2],
            "Tablas": ["Definición de columnas y ubicación de los datos.", 2],
            "Crawlers": ["Exploran datos y deducen su esquema automáticamente.", 1],
            "Jobs ETL": ["Programas que extraen, transforman y cargan datos.", 3],
            "Conexiones": ["Datos de acceso a bases y fuentes externas.", 0],
            "Triggers": ["Inician jobs o crawlers por horario, evento o al terminar otro.", 3],
        },
    },
    emr: {
        que: "Clusters para procesar grandes volúmenes de datos con Spark, Hadoop, Hive o Presto, que se crean cuando los necesitas y se apagan al terminar.",
        patron: "lineal", grupo: [1, 2, "Cluster EMR"],
        nodos: [["Datos en S3", "datos"], ["Nodo maestro", "engranaje"], ["Nodos de trabajo", "servidor"], ["Resultados", "grafico"]],
        pasos: ["El job (step) se envía al nodo maestro, que lee los datos de S3.", "El maestro reparte el trabajo entre los nodos de trabajo.", "Los resultados se guardan en S3 y el cluster puede apagarse para no pagar de más."],
        objetos: {
            "Clusters": ["Conjunto de servidores (maestro y trabajo) con el software de big data instalado.", 1],
            "Steps": ["Cada trabajo enviado al cluster.", 1],
            "Notebooks": ["Cuadernos Jupyter conectados al cluster para exploración.", 1],
            "Studios": ["Entorno web para desarrollar, depurar y programar jobs.", 0],
        },
    },
    kinesis: {
        que: "Datos en tiempo real: recibe flujos continuos (clics, sensores, logs) y permite procesarlos o guardarlos mientras llegan.",
        patron: "lineal",
        nodos: [["Productores", "movil"], ["Kinesis Data Stream", "cola"], ["Consumidor (Lambda)", "funcion"], ["Firehose → S3", "datos"]],
        pasos: ["Millones de productores envían registros al stream.", "El stream los ordena en fragmentos (shards) y los retiene por horas o días.", "Los consumidores los procesan al instante o Firehose los entrega a S3, Redshift u OpenSearch."],
        objetos: {
            "Data Streams": ["Canal de datos en tiempo real dividido en shards, con retención configurable.", 1],
            "Firehose": ["Entrega automática de un flujo hacia S3, Redshift, OpenSearch o HTTP.", 3],
            "Data Analytics": ["Consultas SQL o Flink sobre el flujo mientras pasa.", 2],
            "Video Streams": ["Ingesta y almacenamiento de video de cámaras para análisis.", 0],
        },
    },
    msk: {
        que: "Apache Kafka administrado: plataforma de mensajería y flujos de eventos con alto volumen, sin operar los brokers.",
        patron: "abanico",
        nodos: [["Productor", "servidor"], ["Cluster MSK (topics)", "cola"], ["Consumidor A", "servidor"], ["Consumidor B", "servidor"]],
        pasos: ["Los productores publican eventos en un topic de Kafka.", "MSK los guarda de forma replicada y ordenada en particiones.", "Varios consumidores leen los mismos eventos de forma independiente, cada uno a su ritmo."],
        objetos: {
            "Clusters": ["Los brokers de Kafka repartidos en varias zonas, con almacenamiento.", 1],
            "Configuraciones": ["Parámetros de Kafka aplicables a los clusters.", 1],
            "Conectores": ["Mueven datos entre Kafka y otros sistemas (MSK Connect).", 1],
        },
    },
    opensearch: {
        que: "Búsqueda y análisis de texto y logs (OpenSearch/Elasticsearch): indexa documentos y responde búsquedas complejas en milisegundos.",
        patron: "lineal",
        nodos: [["Logs y documentos", "archivo"], ["Dominio OpenSearch", "lupa"], ["Dashboards", "grafico"]],
        pasos: ["Tus aplicaciones envían documentos y logs al dominio, que los indexa.", "Los usuarios buscan y filtran y ven gráficos en OpenSearch Dashboards."],
        objetos: {
            "Dominios": ["Cluster de OpenSearch con nodos de datos y maestros.", 1],
            "Colecciones Serverless": ["Búsqueda o series de tiempo sin administrar cluster.", 1],
            "Índices": ["Colección de documentos indexados, similar a una tabla.", 1],
        },
    },
    quicksight: {
        que: "Inteligencia de negocios: conecta tus datos y crea paneles interactivos que se comparten con tu equipo desde el navegador.",
        patron: "lineal",
        nodos: [["Fuentes (Athena, RDS, S3)", "datos"], ["Dataset (SPICE)", "datos"], ["Análisis", "lupa"], ["Dashboard", "grafico"]],
        pasos: ["Conectas una fuente de datos.", "Preparas un dataset, que puede cargarse en memoria SPICE para respuestas rápidas.", "Construyes gráficos y publicas un dashboard que los usuarios consultan."],
        objetos: {
            "Dashboards": ["Panel publicado y compartido con usuarios y grupos.", 3],
            "Análisis": ["Espacio de trabajo donde se diseñan los gráficos antes de publicarlos.", 2],
            "Datasets": ["Datos preparados (campos, filtros, cálculos) para usar en gráficos.", 1],
            "Data Sources": ["Conexiones a las bases y archivos de origen.", 0],
            "Usuarios": ["Personas con acceso a QuickSight y su rol (autor, lector).", 3],
        },
    },
    lakeformation: {
        que: "Construye y gobierna un data lake: define quién puede ver qué tablas, columnas y filas, desde un solo lugar.",
        patron: "lineal",
        nodos: [["Datos en S3", "datos"], ["Lake Formation", "candado"], ["Permisos y LF-Tags", "clave"], ["Athena / Redshift / EMR", "lupa"]],
        pasos: ["Registras en Lake Formation las ubicaciones de S3 que forman el lago.", "Defines los permisos por tabla, columna o etiqueta.", "Los servicios de análisis piden datos y reciben solo lo que su usuario puede ver."],
        objetos: {
            "Data Lakes": ["Ubicaciones de S3 registradas y administradas centralmente.", 0],
            "Permisos": ["Concesiones por base, tabla, columna o fila.", 2],
            "LF-Tags": ["Etiquetas para asignar permisos por categoría en vez de recurso por recurso.", 2],
        },
    },
    datazone: {
        que: "Catálogo y portal de datos: los equipos publican, descubren y piden acceso a datos de la empresa con reglas de gobierno.",
        patron: "lineal",
        nodos: [["Productor de datos", "usuario"], ["Catálogo DataZone", "carpeta"], ["Solicitud de acceso", "clave"], ["Consumidor", "usuario"]],
        pasos: ["Un equipo publica sus datos en el catálogo con descripción.", "Otro equipo los busca y solicita suscribirse.", "Tras la aprobación, el consumidor accede a los datos en su proyecto."],
        objetos: {
            "Dominios": ["Espacio de gobierno de datos de la organización.", 1],
            "Proyectos": ["Espacio de trabajo de un equipo con sus datos y herramientas.", 0],
        },
    },
    datapipeline: {
        que: "Servicio clásico para mover y transformar datos según un horario entre servicios de AWS y orígenes locales. Hoy se prefiere Glue, Step Functions o MWAA.",
        patron: "lineal",
        nodos: [["Origen", "datos"], ["Pipeline", "reloj"], ["Recurso de cómputo", "servidor"], ["Destino", "datos"]],
        pasos: ["El pipeline define un horario y las dependencias entre actividades.", "Lanza un recurso de cómputo que ejecuta la actividad.", "Los datos transformados se escriben en el destino y el recurso se apaga."],
        objetos: { "Pipelines": ["Definición de actividades, horarios y recursos de la tarea de datos.", 1] },
    },
};
